import { instance } from "api/apiBase";
import { toast } from "react-toastify";

export const resumeApplicationApiCall = (id: string | number) =>
  instance.post(`/portal/v1/applications/${id}/resume`);

const placeOnHoldApplicationApiCall = (id: string | number) =>
  instance.post(`/portal/v1/applications/${id}/place_on_hold`);

export const resumeApplication = ({
  applicationId,
  onSuccess
}: {
  applicationId: string | number;
  onSuccess?: () => Promise<void> | void;
}) => {
  return toast.promise(
    resumeApplicationApiCall(applicationId).then((d) => {
      return onSuccess ? onSuccess() : d;
    }),
    {
      pending: "Resuming application...",
      success: "Application resumed",
      error: "Filed to resume application"
    }
  );
};

export const placeOnHoldApplication = ({
  applicationId,
  onSuccess
}: {
  applicationId: string | number;
  onSuccess?: () => Promise<void> | void;
}) => {
  return toast.promise(
    placeOnHoldApplicationApiCall(applicationId).then((d) => {
      return onSuccess ? onSuccess() : d;
    }),
    {
      pending: "Placing application on hold...",
      success: "Application placed on hold successfully",
      error: "Failed to place application on hold."
    }
  );
};
